import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateDeal.css';
import API_BASE_URL from './config';
import { FaArrowLeft, FaStar } from 'react-icons/fa';


const CreateDeal = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    discountValue: '',
    description: '',
    startDate: '',
    endDate: '',
    terms: '',
    image: null,
    merchantName: '',
    merchantAddress: '',
    mrp: '',
    customerDiscountPrice: '',
    discountdostCommissionPrice: '',
    customerBuyPrice: '',
  });
  const [loading, setLoading] = useState(false); // New
  const [showPreview, setShowPreview] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else if (name === 'image') {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    const { mrp, discountValue } = formData;
    const mrpNum = parseFloat(mrp);
    const discountPercent = parseFloat(discountValue);

    if (!isNaN(mrpNum) && !isNaN(discountPercent)) {
      const discount = (mrpNum * discountPercent) / 100;
      const customerPrice = mrpNum - discount;
      const commission = discount * 0.10;

      setFormData(prev => ({
        ...prev,
        customerDiscountPrice: discount.toFixed(2),
        discountdostCommissionPrice: commission.toFixed(2),
        customerBuyPrice: customerPrice.toFixed(2),
      }));
    }
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loading state

    // Validate required fields
    const requiredFields = ['title', 'category', 'discountValue', 'description', 'startDate', 'endDate', 'terms', 'merchantName', 'merchantAddress', 'mrp'];
    for (const field of requiredFields) {
      if (!formData[field]) {
        alert(`Please fill in the ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
        setLoading(false);
        return;
      }
    }

    formData.discountValue = formData.discountValue.replace(/[₹%]/g, '');

    const form = new FormData();
    Object.keys(formData).forEach(key => {
      if (key === 'image') {
        if (formData.image) form.append(key, formData.image); // Only append if image exists
      } else {
        form.append(key, formData[key]);
      }
    });

    form.append('customerDiscountPrice', formData.customerDiscountPrice);
    form.append('discountdostCommissionPrice', formData.discountdostCommissionPrice);
    form.append('customerBuyPrice', formData.customerBuyPrice);
    form.append('mrp', formData.mrp);

    const merchantId = localStorage.getItem('merchantId');
    form.append('merchantId', merchantId);



    try {
      const response = await fetch(`${API_BASE_URL}/api/deals`, {
        method: 'POST',
        body: form,
      });
      const result = await response.json();
      if (response.ok) {
        alert('Submission is successful and it will be uploaded upon internal approval!');
        setFormData({
          title: '',
          category: '',
          discountType: '',
          discountValue: '',
          description: '',
          startDate: '',
          endDate: '',
          terms: '',
          image: null,
          merchantName: '',
          merchantAddress: '',
        });
        navigate('/merchant-dashboard'); // Redirect to Dashboard
      } else {
        alert('Error: ' + (result.error || result.message || 'Failed to create deal'));
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Error submitting deal: ' + error.message);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <>
      <div className="deal-form-wrapper">
        <button className="back-btn" onClick={() => navigate('/merchant-dashboard')} disabled={loading}>
          <FaArrowLeft />
        </button>
        <h2>Create a New Deal</h2>
        <form className="deal-form" onSubmit={handleSubmit} encType="multipart/form-data">
          <label>
            Deal Title
            <input
              type="text"
              name="title"
              placeholder="e.g. 50% Off Health Checkup at Krishna Hospital"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Category
            <select name="category" value={formData.category} onChange={handleChange} required>
              <option value="">Select</option>
              <option value="Restaurants">Restaurants</option>
              <option value="Retail">Retail</option>
              <option value="Entertainment">Entertainment</option>
              <option value="Spa & Wellness">Spa & Wellness</option>
              <option value="Health">Health</option>
            </select>
          </label>

          <label>
            Merchant Name
            <input
              type="text"
              name="merchantName"
              placeholder="e.g. Krishna Hospital"
              value={formData.merchantName}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Merchant Address
            <input
              type="text"
              name="merchantAddress"
              placeholder="e.g. 123 Main St, City"
              value={formData.merchantAddress}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Total Discount Percentage (%)
            <input
              type="number"
              name="discountValue"
              placeholder="e.g. 20"
              value={formData.discountValue}
              onChange={handleChange}
              min="1"
              max="100"
              required
            />
          </label>

          <label>
            Usual Price (MRP in ₹)
            <input
              type="number"
              name="mrp"
              placeholder="e.g. 1000"
              value={formData.mrp || ''}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Description
            <textarea
              name="description"
              placeholder="Brief details about the offer"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Start Date
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            End Date
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Terms & Conditions
            <textarea
              name="terms"
              placeholder="Any limitations, conditions etc."
              value={formData.terms}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Upload Deal Banner
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
            />
            <small className="image-guidelines">
              Recommended image size: <strong>1200×600 px</strong> (2:1 aspect ratio), JPG or PNG format.
            </small>
          </label>

          <div className="button-row">
            <button
              type="button"
              className="preview-btn"
              onClick={() => setShowPreview(!showPreview)}
            >
              {showPreview ? 'Hide Preview' : 'Preview'}
            </button>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Creating Deal...' : 'Create Deal'}
            </button>
          </div>
        </form>
      </div>

      {showPreview && (
        <div className="deal-preview-wrapper">
          <div className="deal-preview-card">
            <img
              src={formData.image ? URL.createObjectURL(formData.image) : '/placeholder.jpg'}
              alt={formData.title}
            />
            <div className="deal-badge">
              {formData.discountType === 'Percentage'
                ? `${formData.discountValue}% Off`
                : `₹${formData.discountValue} Off`}
            </div>
            <div className="deal-info">
              <h4>{formData.title || 'Sample Deal Title'}</h4>
              <span className="merchant-name">{formData.merchantName || 'Merchant Name'}</span>
              <span className="expiry">
                Expires {formData.endDate ? new Date(formData.endDate).toLocaleDateString('en-IN') : 'dd-mm-yyyy'}
              </span>
              <p className="desc">{formData.description || 'Short description of the offer.'}</p>
              <div className="rating-price">
                <div className="rating">
                  <FaStar className="star" /> 4.5
                  <span className="reviews">(50 reviews)</span>
                </div>
                <div className="price">
                  <span className="original">₹{formData.mrp}</span>
                  <span className="new">₹{formData.customerBuyPrice}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateDeal;